import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import NewsSlider from "./NewsSlider";
const LatestInsights = () => {
  const { ref, inView } = useInView({ triggerOnce: false, threshold: 0.2 });

  return (
    <>
    
    <div className="p-5 md:p-10 lg:p-16" ref={ref}><br /><br />
      {/* Animated Section */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        className="relative flex flex-col items-center"
      >
        {/* Button Animation */}
        <motion.button
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="bg-[#432DD7] text-white font-[Nunito] text-[12px] md:text-[16px] w-[180px] md:w-[229px] h-[45px] md:h-[60px] rounded-full font-medium"
        >
          Media Coverage
        </motion.button>

        

        {/* Heading */}
        <motion.h2
          className="text-center text-[22px] md:text-[30px] lg:text-[40px] font-bold  mt-4"
          style={{ fontFamily: "PT Sans" }}
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          Media Coverage by Godhani Technologies
        </motion.h2>

        <motion.h2
          className="text-center text-[22px] md:text-[30px] lg:text-[40px] font-[Allison]"
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
          transition={{ duration: 0.6, delay: 0.5 }}
        >
          We Have Coverage by.
        </motion.h2>
        {/* <div className="mt-10 flex flex-col md:flex-row md:flex-wrap gap-5 justify-center items-center w-full">
          {data.map((items, index) => (
            <motion.div
              key={items.id}
              className="w-full sm:w-[340px] md:w-[330px] lg:w-[360px] xl:w-[380px] h-auto rounded-[10px] bg-[#FFFFFF33] border-2 border-[#FFFFFF33] p-5"
              initial={{ opacity: 0, y: 30 }}
              animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
              transition={{ duration: 0.6, delay: 0.2 * index }}
            >
              <img src={items.img} alt="" className="w-full h-[180px] md:h-[220px] lg:h-[250px] rounded-md" />
              
            
              <div className="flex text-white mt-3 gap-5 text-[14px] md:text-[16px]">
                <div className="flex items-center">
                  <i className="fa-solid fa-calendar"></i>
                  &nbsp;
                  <p>{items.date}</p>
                </div>
                <div className="flex items-center">
                  <i className="fa-solid fa-user"></i>
                  &nbsp;
                  <p className="font-[Nunito]">{items.name}</p>
                </div>
              </div>

              
              <h2 className="mt-3 text-[18px] md:text-[22px] font-bold" style={{ color: items.color,fontFamily:'PT Sans' }}>
                {items.ctext}
              </h2>

              
              <p className="mt-2 text-[14px] md:text-[16px] text-white">
                {items.ntext}
              </p>

              
              <button className="mt-4 text-[16px] text-white font-bold">
                {items.btntext}
              </button>
            </motion.div>
          ))}
        </div> */}
      </motion.div>

    </div>
      <NewsSlider/></>
  );
};

export default LatestInsights;
